import { useStore } from '@nanostores/react';
import { memo } from 'react';
import boltDark from '~/images/bolt-token-dark.png';
import boltLight from '~/images/bolt-token-light.png';
import { themeStore } from '~/lib/stores/theme';
import { classNames } from '~/utils/classNames';

interface BoltTokenProps {
  className?: string;
}

export const BoltToken = memo<BoltTokenProps>(({ className }) => {
  const theme = useStore(themeStore);

  return <img className={classNames('h-6 w-6', className)} src={theme === 'dark' ? boltDark : boltLight} />;
});
